module.exports = __webpack_public_path__ + "img/logo-coinbase.0cc6f7a5.svg";